import { Injectable } from '@angular/core'

import { Location, Resource } from '@ti/contracts'
import { BaseCachedStore } from '@ti/core/models/cached-store'

@Injectable({ providedIn: 'root' })
export class LocationsStore extends BaseCachedStore<Location> {
  protected readonly CACHE_KEY: string = 'TI_LOCATIONS'
  protected readonly CHECK_RESOURCE_ACCESS = Resource.Location
  protected readonly MAX_ITEMS = 1000

  protected override loadAll() {
    return this.api.fleet.locations.list({ pageSize: this.MAX_ITEMS })
  }

  protected override loadById(ids: string[]) {
    return this.api.fleet.locations.list({
      filter: { id: { in: ids } },
      pageSize: this.MAX_ITEMS,
    })
  }

  protected override loadSnapshot() {
    return this.api.fleet.locations.list({
      select: ['id', 'updatedAt'],
      pageSize: this.MAX_ITEMS,
    }) as Promise<{ id: string; updatedAt: Date }[]>
  }
}
